import { Bot } from "lucide-react";
import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const reais = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/**
 * Linha "CLEO (WhatsApp)" do Relatório de Módulos: quanto do período foi pedido
 * anotado pela CLEO na conversa. Esses pedidos entram como Cardápio, então a
 * linha é um recorte do card Cardápio, não um módulo a mais. Sem pedido no
 * período, não aparece.
 */
export default function VendasCleoPeriodo({ periodo }) {
  const [dados, setDados] = useState(null);
  const { inicio, fim } = periodo || {};

  useEffect(() => {
    if (!inicio || !fim) return undefined;
    let vivo = true;
    fetch(`${API_URL}/api/chatbot/vendas-cleo?data_inicio=${inicio}&data_fim=${fim}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` }, cache: "no-store",
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (vivo) setDados(d); })
      .catch(() => { if (vivo) setDados(null); });
    return () => { vivo = false; };
  }, [inicio, fim]);

  if (!dados || !dados.pedidos) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-2xl border bg-emerald-500/5 p-4 text-sm" data-e2e="relatorio-vendas-cleo">
      <span className="flex items-center gap-1.5 font-semibold"><Bot className="h-4 w-4 text-emerald-500" /> CLEO (WhatsApp)</span>
      <span><b>{dados.pedidos}</b> {dados.pedidos === 1 ? "pedido anotado" : "pedidos anotados"}</span>
      <span><b>{reais(dados.faturamento)}</b> em vendas</span>
      <span>ticket médio <b>{reais(dados.ticket_medio)}</b></span>
      <span className="text-xs text-muted-foreground">Pedidos que a CLEO anotou pela conversa. Já estão somados no Cardápio.</span>
    </div>
  );
}
